import React from "react";
import "./LayoutSlider.css";
import { HomeSlider } from "../HomeSlider";
import { HomeAboutUs } from "../HomeAboutUs";

const LayoutSlider = () => {
  return (
    <div className="layoutSlider">
      <HomeSlider />
      <HomeAboutUs />
    </div>
  );
};

export { LayoutSlider };